// src/data/newsDetails.js

const newsDetails = {
  "trien-lam-my-thuat-thieu-nhi-2025": {
    slug: "trien-lam-my-thuat-thieu-nhi-2025",
    title: "Triển lãm Mỹ thuật Thiếu nhi 2025",
    date: "04/08/2025",
    summary:
      "Triển lãm thường niên của Design24 quy tụ hàng trăm tác phẩm đặc sắc của học viên trên toàn quốc, là sân chơi lớn để các em thể hiện tư duy sáng tạo.",
    image: "/images/art/news/highlight.webp",
    author: "Design24 Team",
    category: "Sự kiện",
    tags: ["triển lãm", "mỹ thuật thiếu nhi", "sáng tạo", "Design24"],
    content: `
      <p>Triển lãm Mỹ thuật Thiếu nhi 2025 quy tụ các tác phẩm đa dạng từ các em học viên trên toàn quốc, tạo nên không gian nghệ thuật đầy sắc màu và cảm hứng.</p>
      <p>Khách tham quan được trải nghiệm các hoạt động tương tác, tham gia workshop sáng tạo và gặp gỡ các nghệ sĩ trẻ tài năng.</p>
      <p>Sự kiện mở ra cơ hội giao lưu học hỏi và phát triển kỹ năng mỹ thuật cho thế hệ thiếu nhi.</p>
    `,
    relatedNews: [
      { slug: "khai-giang-khoa-hoc-moi", title: "Khai giảng khóa học mới" },
      {
        slug: "workshop-ve-mau-nuoc-cho-thieu-nhi",
        title: "Workshop vẽ màu nước cho thiếu nhi",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery1.webp",
        caption: "Các tác phẩm tranh thiếu nhi trưng bày tại triển lãm",
      },
      {
        src: "/images/art/news/gallery2.webp",
        caption: "Bé tham gia workshop sáng tạo tại sự kiện",
      },
    ],
  },

  "khai-giang-khoa-hoc-moi": {
    slug: "khai-giang-khoa-hoc-moi",
    title: "Khai giảng khóa học mới",
    date: "01/08/2025",
    summary:
      "Khóa học mỹ thuật thiếu nhi mới của Design24 chính thức khai giảng với chương trình đa dạng và đội ngũ giảng viên chuyên nghiệp.",
    image: "/images/art/news/news1.webp",
    author: "Giảng viên Design24",
    category: "Thông báo",
    tags: ["khai giảng", "khóa học", "mỹ thuật thiếu nhi"],
    content: `
      <p>Khóa học mới chú trọng phát triển tư duy sáng tạo và kỹ năng vẽ cho học viên ở mọi độ tuổi.</p>
      <p>Chương trình giảng dạy kết hợp lý thuyết và thực hành, giúp học viên tiếp cận nhanh và hiệu quả.</p>
      <p>Đăng ký ngay để nhận ưu đãi học phí mùa khai giảng!</p>
    `,
    relatedNews: [
      {
        slug: "trien-lam-my-thuat-thieu-nhi-2025",
        title: "Triển lãm Mỹ thuật Thiếu nhi 2025",
      },
      {
        slug: "hoc-ve-manga-tu-can-ban-den-nang-cao",
        title: "Học vẽ Manga từ căn bản đến nâng cao",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery3.webp",
        caption: "Lễ khai giảng sôi động với sự tham gia của đông đảo học viên",
      },
    ],
  },

  "workshop-ve-mau-nuoc-cho-thieu-nhi": {
    slug: "workshop-ve-mau-nuoc-cho-thieu-nhi",
    title: "Workshop vẽ màu nước cho thiếu nhi",
    date: "25/07/2025",
    summary:
      "Workshop giúp các bé khám phá kỹ thuật vẽ màu nước linh hoạt, phát huy tối đa khả năng sáng tạo và cảm nhận màu sắc.",
    image: "/images/art/news/news2.webp",
    author: "Bé Artist Team",
    category: "Workshop",
    tags: ["workshop", "màu nước", "thiếu nhi", "kỹ thuật vẽ"],
    content: `
      <p>Workshop hướng dẫn kỹ thuật pha màu, tạo lớp màu và hiệu ứng ánh sáng để hoàn thiện tác phẩm màu nước.</p>
      <p>Các bé được thực hành dưới sự hỗ trợ tận tình của giảng viên.</p>
      <p>Sự kiện nhằm nâng cao kỹ năng và sự tự tin trong biểu đạt nghệ thuật của trẻ.</p>
    `,
    relatedNews: [
      {
        slug: "trien-lam-my-thuat-thieu-nhi-2025",
        title: "Triển lãm Mỹ thuật Thiếu nhi 2025",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery4.webp",
        caption: "Các bé tập trung nhiệt tình trong buổi workshop màu nước",
      },
    ],
  },

  "hoc-ve-manga-tu-can-ban-den-nang-cao": {
    slug: "hoc-ve-manga-tu-can-ban-den-nang-cao",
    title: "Học vẽ Manga từ căn bản đến nâng cao",
    date: "20/07/2025",
    summary:
      "Khóa học Manga toàn diện giúp học viên từ mới bắt đầu đến nâng cao xây dựng kỹ năng vẽ truyện tranh Nhật Bản đặc sắc.",
    image: "/images/art/news/news3.webp",
    author: "Artist Manga Pro",
    category: "Khóa học",
    tags: ["manga", "vẽ truyện tranh", "kỹ thuật vẽ", "mỹ thuật thiếu nhi"],
    content: `
      <p>Chương trình đào tạo từ kỹ thuật vẽ cơ bản, dựng nhân vật đến xây dựng cốt truyện và phối cảnh đặc sắc.</p>
      <p>Học viên được hướng dẫn bởi họa sĩ truyện tranh chuyên nghiệp với nhiều năm kinh nghiệm.</p>
      <p>Phù hợp với các bạn đam mê truyện tranh và muốn phát triển tài năng vẽ Manga.</p>
    `,
    relatedNews: [
      { slug: "khai-giang-khoa-hoc-moi", title: "Khai giảng khóa học mới" },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery5.webp",
        caption: "Buổi học lý thuyết và thực hành vẽ Manga",
      },
    ],
  },

  "5-ky-thuat-to-mau-chi-nang-cao": {
    slug: "5-ky-thuat-to-mau-chi-nang-cao",
    title: "5 kỹ thuật tô màu chì nâng cao",
    date: "28/07/2025",
    summary:
      "Khám phá 5 kỹ thuật tô màu chì nâng cao giúp tăng chiều sâu và biểu cảm cho tranh vẽ.",
    image: "/images/art/news/tip1.webp",
    author: "Chuyên gia Mỹ thuật",
    category: "Kiến thức hội họa",
    tags: ["tô màu chì", "kỹ thuật vẽ", "hội họa nâng cao"],
    content: `
      <p>Trình bày chi tiết 5 kỹ thuật tô màu chì nâng cao: đổ bóng, pha màu, tạo texture, layering, blending.</p>
      <p>Mỗi kỹ thuật giúp tăng chiều sâu, độ chân thực và sức sống cho tranh.</p>
      <p>Bài học phù hợp cho học viên muốn phát triển kỹ năng vẽ tay chuyên nghiệp.</p>
    `,
    relatedNews: [
      {
        slug: "tu-duy-bo-cuc-trong-tranh-thieu-nhi",
        title: "Tư duy bố cục trong tranh thiếu nhi",
      },
      {
        slug: "cach-truyen-cam-xuc-qua-net-ve",
        title: "Cách truyền cảm xúc qua nét vẽ",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery6.webp",
        caption:
          "Ví dụ về kỹ thuật tô màu chì với hiệu ứng ánh sáng và đổ bóng",
      },
    ],
  },

  "tu-duy-bo-cuc-trong-tranh-thieu-nhi": {
    slug: "tu-duy-bo-cuc-trong-tranh-thieu-nhi",
    title: "Tư duy bố cục trong tranh thiếu nhi",
    date: "18/07/2025",
    summary:
      "Hiểu và vận dụng tư duy bố cục giúp tranh thiếu nhi trở nên hài hòa và thu hút hơn.",
    image: "/images/art/news/tip2.webp",
    author: "Giảng viên Design24",
    category: "Kiến thức hội họa",
    tags: ["bố cục", "tranh thiếu nhi", "nghệ thuật", "tư duy sáng tạo"],
    content: `
      <p>Bố cục là yếu tố then chốt giúp tác phẩm hội họa trở nên thu hút và truyền tải thông điệp hiệu quả.</p>
      <p>Bài viết chia sẻ các nguyên tắc bố cục cơ bản, cách sắp xếp các yếu tố trong tranh thiếu nhi một cách hài hòa.</p>
      <p>Phương pháp thực hành giúp phát triển tư duy thẩm mỹ và sáng tạo cho học viên.</p>
    `,
    relatedNews: [
      {
        slug: "5-ky-thuat-to-mau-chi-nang-cao",
        title: "5 kỹ thuật tô màu chì nâng cao",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery7.webp",
        caption: "Sơ đồ bố cục tranh thiếu nhi tiêu biểu",
      },
    ],
  },

  "cach-truyen-cam-xuc-qua-net-ve": {
    slug: "cach-truyen-cam-xuc-qua-net-ve",
    title: "Cách truyền cảm xúc qua nét vẽ",
    date: "10/07/2025",
    summary:
      "Nắm bắt bí quyết truyền tải cảm xúc sống động qua từng đường nét trong tranh vẽ.",
    image: "/images/art/news/tip3.webp",
    author: "Họa sĩ Nguyễn Văn A",
    category: "Kiến thức hội họa",
    tags: ["cảm xúc", "nét vẽ", "truyền tải cảm xúc", "hội họa"],
    content: `
      <p>Cảm xúc trong tranh không chỉ đến từ màu sắc mà còn từ từng đường nét được thể hiện khéo léo.</p>
      <p>Bài viết phân tích cách sử dụng độ dày, độ nghiêng, tốc độ nét vẽ để truyền tải cảm xúc khác nhau.</p>
      <p>Áp dụng các kỹ thuật này giúp tác phẩm trở nên sống động và truyền cảm hơn.</p>
    `,
    relatedNews: [
      {
        slug: "5-ky-thuat-to-mau-chi-nang-cao",
        title: "5 kỹ thuật tô màu chì nâng cao",
      },
    ],
    imagesGallery: [
      {
        src: "/images/art/news/gallery8.webp",
        caption: "Ví dụ các đường nét thể hiện cảm xúc trong tranh",
      },
    ],
  },
};

export default newsDetails;
